
<div class="ng-content" [ngClass]="{'hidden-menu-content': !isMenuVisible}">
    <app-menu></app-menu>
    <app-header></app-header>
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>